import React, {PureComponent} from "react"
import {Row} from "react-bootstrap"

import CardImage from "@irati/ui/src/Layout/CardImage"
import Link from "@irati/ui/src/Link"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import {H1} from "@irati/ui/src/Typography"

import iconLaunch from "@irati/ui/images/launch.svg"
import billing from "@irati/ui/images/billing.svg"
import training from "@irati/ui/images/training.svg"
import customisation from "@irati/ui/images/customisation.svg"
import peoplemgt from "@irati/ui/images/peoplemgt.svg"
import tracking from "@irati-tracking/admin"

import HelpTrackingKeys from "../../constants/HelpTrackingKeys"

const cards = [
  {
    href: "admin.containers.help.webinars.href",
    imageSrc: training,
    imageAlt: "admin.containers.help.card.webinars.alt",
    title: "admin.containers.help.card.webinars.title",
    description: "admin.containers.help.card.webinars.description",
    trackingKey: HelpTrackingKeys.trainingWebinars
  },
  {
    href: "admin.containers.help.launching.href",
    imageSrc: iconLaunch,
    imageAlt: "admin.containers.help.card.launching.alt",
    title: "admin.containers.help.card.launching.title",
    description: "admin.containers.help.card.launching.description",
    trackingKey: HelpTrackingKeys.launching
  },
  {
    href: "admin.containers.help.customisation.href",
    imageSrc: customisation,
    imageAlt: "admin.containers.help.card.customisation.alt",
    title: "admin.containers.help.card.customisation.title",
    description: "admin.containers.help.card.customisation.description",
    trackingKey: HelpTrackingKeys.customisation
  },
  {
    href: "admin.containers.help.management.href",
    imageSrc: peoplemgt,
    imageAlt: "admin.containers.help.card.management.alt",
    title: "admin.containers.help.card.management.title",
    description: "admin.containers.help.card.management.description",
    trackingKey: HelpTrackingKeys.peopleManagement
  },
  {
    href: "admin.containers.help.payments.href",
    imageSrc: billing,
    imageAlt: "admin.containers.help.card.payments.alt",
    title: "admin.containers.help.card.payments.title",
    description: "admin.containers.help.card.payments.description",
    trackingKey: HelpTrackingKeys.billingPayments
  }
]

interface Props extends InjectIntl {}

class Help extends PureComponent<Props> {
  componentDidMount(): void {
    tracking.viewHelp()
  }

  handleTracking = (trackingKey: string) => {
    switch (trackingKey) {
      case HelpTrackingKeys.trainingWebinars:
        tracking.viewTrainingWebinars()
        break
      case HelpTrackingKeys.launching:
        tracking.viewLaunchingPerkbox()
        break
      case HelpTrackingKeys.customisation:
        tracking.viewCustomisation()
        break
      case HelpTrackingKeys.peopleManagement:
        tracking.viewPeopleManagement()
        break
      case HelpTrackingKeys.billingPayments:
        tracking.viewBillingPayments()
        break
    }
  }

  render() {
    const {formatMessage} = this.props
    return (
      <>
        <H1 marginBottom={4}>
          <FormattedMessage id="admin.containers.help.heading.help" />
        </H1>
        <Row>
          {cards.map((card, i) => {
            return (
              <Link
                href={formatMessage({id: card.href})}
                onClick={() => this.handleTracking(card.trackingKey)}
                target="_blank"
                key={`card${i}`}>
                <CardImage
                  colSize={6}
                  imageSrc={card.imageSrc}
                  imageAlt={formatMessage({id: card.imageAlt})}
                  imagePosition="left"
                  imageSize={80}
                  title={formatMessage({id: card.title})}
                  description={formatMessage({id: card.description})}
                  rollover />
              </Link>
            )
          })}
        </Row>
      </>
    )
  }
}

export default injectIntl(Help)
